function initReperes(blocsContainer, reload, callback) {
    // Initialisation des QC et ouverture de la fenêtre montrant les repères

    // On charge la fenêtre. Ensuite, on ne fait que la faire apparaître pour édition.
    chargerReperes(blocsContainer, reload, callback);

}

function afficherReperes() {

    var reperesContainer = getReperesContainer($('div#blocs-container'));
    var modeReadOnly = estReadOnly(reperesContainer); // ($('#mode-read-only').val());
    if (!modeReadOnly) {

        initEventsReperes(reperesContainer);
    }

    if (modeLoad == ModeSave.FICHE) {
        btnNaviguationDateEvenements();
    }

    // ajouté ceci, car par exemple dans l'étape propagation faut attendre que les repères soient bien chargés avant de continuer certaines initialisations
    if (typeof(callback) != 'undefined' && callback) {
        var reponse = {};
        callback(reponse);
    }
}

function chargerReperes(blocsContainer, reload, callback) {

    if (!reload) {
        return;
    }

    var listeBatiments = [];
    var listeDateEvenement = [];

    if (modeLoad == ModeSave.FICHE) {
        var idFormulaire = $('#current-id-formulaire').val();
        if (estBatiment(idFormulaire)) {
            listeBatiments.push($('#current-id-batiment').val());
        }
        listeDateEvenement.push($('#date-evenement').val());
    }
    if (modeLoad == ModeSave.WIZARD) {
        // FB, issue 15690 : il y a 2 "<div>' avec id="contenu" et ça empêche de faire la sauvegarde dans le
        //                   wizard quand on revient en arrière dans les étapes si le modal de repères est dans le html
        // FB, issue 15561 : les QC ne sont pas cliquables dans l'étape de Propagation (15574), alors pour le
        //                   moment, on ne charge pas les repères dans le html pour l'étape de Propagation. Les repères
        //                   continuent d'être copiés automatiquement pour la propagation.
        return;
    }

    $('#reperes').html('');
    var thisVariable = $(this);

    if (listeBatiments.length > 0 && !window.isRunningInApp) {

        var titre = "Repères";
        var url = "/gestion-roles/editeur-fiche/repere/";

        var params = {
            liste_batiments: JSON.stringify(listeBatiments),
            liste_date_evenement: JSON.stringify(listeDateEvenement)
        };

        var readOnly = true;

        if (modeLoad == ModeSave.FICHE) {
            readOnly = ($('#mode-read-only').val());
        }
        if (modeLoad == ModeSave.WIZARD) {
            readOnly = ($('#wizard').attr('mode'));
        }

        params['readOnly'] = readOnly;

        params['id_municipalite'] = ($('#headerTitre').attr('code-geographique'));

        var variablesModal = {
            id: "modal-reperes",
            view: "/core/modal/",
            cacherAuChargement: true,
            nePasDetruire: true,
            id_processus: "",
            titre: titre,
            titre_supp: "",
            cacher_footer: true,
            module: "",
            contenuHTML: "",
            template: "",
            template_view: url,
            template_depart: "",
            template_depart_view: "",
            url: "",
            taille: "reperes",
            resultat: "",
            resultat_depart: "",
            wizard: false,
            callback: function (response) {

                var reperesContainer = getReperesContainer(thisVariable);

                // Cacher les repères de fondation selon les types de fondation saisis dans le bloc 15
                cacherRepereParTypeFondationQcb15(reperesContainer);

                // Initialiser les actions sur les repères (clic sur les A,B,C...) et relance du calcul de la classe.
                modalReperesLoaded();

            },
            boutons: [
                {
                    type: "cancel",
                    label: "Fermer",
                    title: "",
                    classSupp: "",
                    afficher: true
                }
            ]
        };

        fenetreModal.creerModal(variablesModal, params);
    }
}

function getReperesContainer(obj) {
    var blocDivision = getBlocDivision(obj, modeLoad);
    var reperesContainer;
    if (modeLoad == ModeSave.FICHE) {
        reperesContainer = $('.container-reperes');
    }
    else {
        var dateEvenement = obj.closest('.avant-container,.apres-container').attr('date-evenement');
        reperesContainer = $('.container-reperes[id-batiment='+ blocDivision.id_batiment +'][date-evenement="'+ dateEvenement +'"]');
    }
    return reperesContainer;
}

function cacherModal(idModal) {
    wait.stop();
    $(idModal).modal('hide');
}


function initBoutonsReperes() {

    // Initialiser les clics sur l'entête des QC et repères (raccourcis)
    $('.liens-reperes').find('a.lien').off('click').on('click', function (e) {
        if (window.isRunningInApp) {
            e.preventDefault();
        }
        $('.liens-reperes').find('a.lien').removeClass('active');
        $('.container-reperes').find('.reperes-modal').css("display", "none");
        $(this).addClass('active');
        var repereBloc = $(this).attr('value');
        $(this).addClass('active');
        $('.container-reperes').find('div[name="' + repereBloc + '"]').css("display", "block");
    });


    //  Gestion du click sur les repères
    $('div#blocs-container').find('[name$="qualiteComplexite"]').off('click').on('click', function () {

        //    On affiche la fenêtre
        $('#modal-reperes').modal('show');

        //  On affiche le repère cliqué et, si nécessaire, on valide qu'il existe, et dans le cas contraire, on doit l'ajouter à l'entête et au body du modal.
        var idComposante;
        var noLigne = $(this).closest('div.sous-bloc-form').attr('no-ligne');

        if ($(this).closest('div.champs-multiple').attr('composante') !== undefined) {
            idComposante = $(this).closest('div.champs-multiple').attr('composante');
        } else {
            idComposante = $(this).closest('div.qc').find('input[name=composante]').val();
        }

        // Ajouter dynamiquement un ou des repères manquants (bloc 59 et 63, par exemple, on l'on peut ajouter des hangars)
        ajouterReperesDynamiques(getReperesContainer($(this)));
        var repereAccordeon = $('#modal-reperes').find('[name="accordion-qc-composante-' + idComposante + '"][no-ligne="' + noLigne + '"]');
        var lien = repereAccordeon.closest('.reperes-modal').attr('name');

        $('#entete-fixe-reperes').find('a.lien[value="' + lien + '"]').trigger('click');
    });


    // action pour se rendre sur le input disabled du QC qui est caché par un div
    $('div#blocs-container').find('#container-qualite-complexite > div').off('click').on('click', function () {
        $(this).closest('#container-qualite-complexite').find("input[disabled]").trigger('click');
    });
}


function ajouterReperesDynamiques(reperesContainer, repereClique) {

    var blocsContainer = reperesContainerToBlocsContainer(reperesContainer);
//    Si l'accordéon est trouvé, mais que l'entête, non, on l'ajoute.
//     Si l'accordéon est trouvé, que l'entête aussi, mais que rien n'a été saisi, on retire de l'affichage.
//    Si l'accordéon est trouvé, que l'entête aussi, mais qu'il est caché, on le décache.
//    Si l'accordéon n'est pas trouvé, on duplique l'accordéon de la compos ante et on ajoute au corps et à l'entête. Nécessaire lorsque pour les blocs 59 et 63, on peut ajouter plusieurs éléments avec chacun son QC propre.
//    Si on a ouvert les QC, sans insérer de données, et que les données pour ce composante dynamique de la fiche sont vides, on cache l'entête, lors de la prochaine ouverture des QC.

//     On traite ensuite le qc cliqué pour traitement.

    var idComposantes = [13, 21, 22, 23, 24];
    for (var index in idComposantes) {
        var idComposante = idComposantes[index];
        var sousBlocQc = blocsContainer.find('.qc').find('[name$="composante"][value="' + idComposante + '"]').closest('.champs-multiple .sous-bloc-form');
        var b63Numero;
        $.each(sousBlocQc, function (index, valeur) {
            var noLigne = $(valeur).attr('no-ligne');
            if ($.inArray(idComposante, [21, 22, 23, 24]) !== -1) {
                b63Numero = $(valeur).find('[name=numero]').val();
            }
            if ($(valeur).not('.nouvelle-ligne').find('.form-control:not(select)[type!="hidden"]').filter(function () {
                    return this.value.length > 0;
                }).length > 0) { // On affiche les QC des lignes qui sont ajoutées et qui ne sont pas vides
                trouverAccordionRepere(reperesContainer, idComposante, noLigne, true, b63Numero);
            } else {
                trouverAccordionRepere(reperesContainer, idComposante, noLigne, false);
            }
        });
    }

    ordonnerEnteteReperes($('.liens-reperes'));

}

function modalReperesLoaded() {
//    On charge les repères dans des div cachés, sauf le courant, qu'on affiche
//    Chaque bouton d'entête est vert (fond) si des données y sont saisies
//    Chaque bouton ouvre son propre QC
    cacherModal('#modal-reperes');

    $('.container-reperes').each(function () {
        var reperesContainer = $(this);

        // on assigne à l'accordion du qc-composante le no de ligne de chaque QC, pour le retrouver plus facilement
        assignerNoLigneReperes(reperesContainer);

        ajouterReperesDynamiques(reperesContainer);
    });

    afficherReperes();

    initBoutonsReperes();

}


function reperesContainerToBlocsContainer(reperesContainer) {
    var blocsContainer = $('#blocs-container');

    if ($('#wizard').length > 0) {
        var dateEvenement = reperesContainer.attr('date-evenement');
        var idBatiment = reperesContainer.attr('id-batiment');
        blocsContainer = $('[id^=accordion-batiment-' + idBatiment + '-]').find('.avant-container[date-evenement="' + dateEvenement + '"],.apres-container[date-evenement="' + dateEvenement + '"]');
    }

    return blocsContainer;
}


function estReadOnly(reperesContainer) {
    if ($('#wizard').length > 0) {
        if ($('#wizard').attr('mode') != 'w') {
            return true;
        }

        var blocsContainer = reperesContainerToBlocsContainer(reperesContainer);
        if (blocsContainer.first().hasClass('avant-container')) {
            return true;
        }

        return false;
    }

    return ($('#mode-read-only').val() != 'False');
}


function trouverAccordionRepere(reperesContainer, idComposante, noLigne, afficher, b63Numero) {

    // si l'accordion est trouvé, on enlève le style display: none
    var accordionQcComposante = reperesContainer.find('[name="accordion-qc-composante-' + idComposante + '"][no-ligne="' + noLigne + '"]');//.removeClass('display-none');
    if (accordionQcComposante.length && b63Numero !== undefined) {
        accordionQcComposante.attr('b63-numero', b63Numero);
    }
    var idBloc;
    var lien;


    if (afficher) {
        var containerAccordion = $(reperesContainer.find('[name="accordion-qc-composante-' + idComposante + '"]'));
        idBloc = containerAccordion.attr('ordre-tri');

        //    Si on a ouvert les QC, sans insérer de données, et que les données pour ce composante dynamique de la fiche sont vides, on cache l'entête, lors de la prochaine ouverture des QC.

        //    Si l'accordéon n'est pas trouvé, on duplique l'accordéon de la composante et on ajoute au corps et à l'entête. Nécessaire lorsque pour les blocs 59 et 63, on peut ajouter plusieurs éléments avec chacun son QC propre.
        if (accordionQcComposante.length == 0) {

            // si l'accordion n'existe pas, il faut l'ajouter. Ceci arrive pour les blocs 59 et 63 qui peuvent avoir plus d'un bloc de repères
            var ligneCourante = containerAccordion.first();
            accordionQcComposante = ligneCourante.clone(false);
            let b63NumeroAvant = accordionQcComposante.attr('b63-numero');

            // remettre les valeurs de défaut, enlever les classe de modification
            accordionQcComposante
                .attr('id-sous-bloc-parent', 'None')
                .attr('no-ligne', noLigne)
                .attr('b63-numero', b63Numero)
                .removeClass('display-none')
                .find('.resultat').html('').end()
                .find('.accordion-toggle').end()
                .find('.repere')
                .attr('id-repere-defaut', 'None')
                .attr('id-sous-bloc-parent', 'None')
                .attr('id-model-instance', 'None')
                .attr('bloc-editable', 'True')
                .find('.selected').removeClass('selected').end()
                .find('.choix-classe').html('').end()
                .removeClass('repere-modifie');
            // L'accordéon est inséré dans un div

            // containerAccordion.parent().last().after(accordionQcComposante);
            modifierRepereAccordion(accordionQcComposante, noLigne, b63NumeroAvant, b63Numero);
            lien = accordionQcComposante.find('a').attr('href');
            containerAccordion.parent().last().after('<div id=repere-' + accordionQcComposante.attr('ordre-tri') + '" name="' + lien + '" class="reperes-modal">');
            $('div[name="' + lien + '"]').append(accordionQcComposante);


            // ensuite, on ordonne les blocs de repères par ordre de tri et par no de ligne
            ordonnerReperes(reperesContainer);

            var modeReadOnly = estReadOnly(reperesContainer); // ($('#mode-read-only').val());
            if (!modeReadOnly) {
                // initialiser à nouveau le click sur les repères vu qu'on ne garde pas les évènements lors du clone de l'accordion
                initEventsReperes(reperesContainer);
            }
        } else {
            lien = accordionQcComposante.find('a').attr('href');
        }
    }


    //    Si l'entête n'est pas trouvé, on l'ajoute.
    // Si l'entête est caché, on le décache.
    if (afficher) {
        let ordreTriComposante = accordionQcComposante.attr('ordre-tri-composante');
        ajouterRepereDynamiqueAEntete(lien, idComposante, idBloc, noLigne, ordreTriComposante, b63Numero);
    } else {
        cacherRepereDynamiqueAEntete(lien);
    }

    return accordionQcComposante;
}


function ajouterRepereDynamiqueAEntete(lien, idComposante, idBloc, noLigne, ordreTriComposante, b63Numero) {
    var repereLienAccordeon = $('.container-reperes').find('a[href=' + lien + ']');
    var numeroComposante = b63Numero ? b63Numero : noLigne;
    var repereLien = $('#entete-fixe-reperes').find('a.lien[value="' + lien + '"]');
    var lienNom;
    if (repereLien.length > 0) {
        // Si le lien existe mais avait été préalablement désactivé, on ne fait que réactiver
        lienNom = repereLien.text().trimRight().split('-')[1];
        var indexClasseQc = lienNom.indexOf('(');
        if (indexClasseQc !== -1) {
            lienNom = lienNom.slice(0, indexClasseQc).trimRight();
        }
        let lienNomAvant = lienNom;
        let lienNomSplit = lienNomAvant.split(' ');
        lienNom = lienNom.replace(lienNomSplit[lienNomSplit.length-1], numeroComposante);
        repereLien.html(repereLien.html().replace(lienNomAvant, lienNom));
        afficherRepereDynamiqueAEntete(lien);
    } else {
        // Si le lien n'existe pas, il faut créer le lien dans l'entête
        lienNom = repereLienAccordeon.text().match(/\-(.*)/)[1];
        let lienNomSplit = lienNom.split(' ');
        lienNom = lienNom.replace(lienNomSplit[lienNomSplit.length-1], numeroComposante);
        var lienRepere = '<a name="repere-' + idBloc + '" ordre-tri="' + idBloc + '" ordre-tri-composante="' + ordreTriComposante + '" class="lien" value="' + lien + '" href="#!"><span class="lien reperes-modal">' + idBloc + '</span> -' + lienNom + ' <span class="classe-calculee"></span></a>';
        // Activer le lien en insérant le lien à la suite des autres
        $('.liens-reperes').append(lienRepere);
    }
    // Corriger le titre de l'accordéon selon le nom du lien
    let lienNomAccordeon = repereLienAccordeon.text().match(/\-(.*)/)[1];
    repereLienAccordeon.text(repereLienAccordeon.text().replace(lienNomAccordeon, lienNom));
}


function afficherRepereDynamiqueAEntete(lien) {
    $('div[name=' + lien + ']').removeClass('cacher');
}


function cacherRepereDynamiqueAEntete(lien) {
    $('div[name=' + lien + ']').addClass('cacher');
}


function assignerNoLigneReperes(reperesContainer) {
    var accordionsQcComposante = reperesContainer.find('.panel-group[name^="accordion-qc-composante"]');
    var blocsContainer = reperesContainerToBlocsContainer(reperesContainer);
    $.each(accordionsQcComposante, function (index, accordion) {
        // d'abord, on assigne à l'accordion du qc-composante le no de ligne de chaque QC, pour le retrouver plus facilement
        var idSousBlocParent = $(accordion).attr('id-sous-bloc-parent');
        var sousBlocQc;
        var noLigne;
        if (idSousBlocParent != 'None') {
            sousBlocQc = blocsContainer.find('.sous-bloc-form[id-model-instance=' + idSousBlocParent + '] .qc').closest('.sous-bloc-form');
            noLigne = sousBlocQc.attr('no-ligne');
        }
        else {
            // si des repéres sont en suppression, prenons le no de ligne qui est déjà assigné
            var reperes = $(accordion).find('.repere.repere-suppression');
            if (reperes.length > 0) {
                noLigne = $(accordion).attr('no-ligne');
            }
            else {
                var idComposante = $(accordion).find('.container-repere').attr('id-composante');
                sousBlocQc = blocsContainer.find('.qc').find('[name$="composante"][value="' + idComposante + '"]').closest('.champs-multiple .sous-bloc-form');
                noLigne = sousBlocQc.attr('no-ligne');
            }
        }
        if (noLigne == undefined) {
            noLigne = 1;
        }
        $(accordion)
            .attr('no-ligne', noLigne);

        // ensuite, on change le no assigné au nom de la composante selon le no de ligne
        if (idSousBlocParent != 'None') {
            modifierRepereAccordion($(accordion), noLigne);
        }
    });
}

function modifierRepereAccordion(accordion, noLigne, b63NumeroAvant, b63Numero) {
    if (accordion.length > 0 && noLigne !== undefined) {
        var lien = $(accordion).find('.panel-title .accordion-toggle');
        var href = lien.attr('href');
        var indexHref = href.lastIndexOf('-');
        if (indexHref != -1) {
            var noTrouve = href.substr(indexHref + 1);
            if (noTrouve != noLigne) {
                // change le id du div associé au href
                var idQcComposante = $(accordion).find(href).attr('id', href.substr(1, indexHref) + noLigne);
                // change le href
                lien.attr('href', '#' + idQcComposante.attr('id'));
                // change le texte
                var numeroComposanteAvant = b63NumeroAvant ? b63NumeroAvant : noTrouve;
                var numeroComposante = b63Numero ? b63Numero : noLigne;
                var indexTexte = lien.text().lastIndexOf(numeroComposanteAvant);
                lien.contents().last()[0].textContent = lien.text().substr(0, indexTexte) + numeroComposante + lien.text().substr(indexTexte + numeroComposante.length);
            }
        }
    }
}


function ordonnerEnteteReperes(repereEntete) {
    repereEntete.each(function () {
        var divLiensRepere = $(this).find('.lien[name^="repere-"]');
        var divLiens = divLiensRepere.detach();
        var divLiensOrdered = divLiens.sort(function (a, b) {
            var elementA = $(a).attr('ordre-tri');
            var elementB = $(b).attr('ordre-tri');
            if (elementA === elementB) {
                let ordreTriComposanteA = $(a).attr('ordre-tri-composante');
                let ordreTriComposanteB = $(b).attr('ordre-tri-composante');
                if (ordreTriComposanteA === ordreTriComposanteB) {
                    let texteA = $(a).text().match(/\-(.*)/)[1];
                    let texteB = $(b).text().match(/\-(.*)/)[1];
                    return texteA > texteB ? 1 : texteA < texteB ? -1 : 0;
                }
                return ordreTriComposanteA > ordreTriComposanteB ? 1 : ordreTriComposanteA < ordreTriComposanteB ? -1 : 0;
            }
            return elementA > elementB ? 1 : elementA < elementB ? -1 : 0;
        });
        $(this).first().append(divLiensOrdered);
        initBoutonsReperes();
    });
}


function ordonnerReperes(repereContainer) {
    var divAccordionsQcComposante = repereContainer.find('.reperes-modal[id^="repere-"]');
    var divAccordions = divAccordionsQcComposante.detach();
    var divAccordionsOrderedDivs = divAccordions.sort(function (a, b) {
        var elementA = parseInt($(a).find('.panel-group').attr('ordre-tri'));
        var elementB = parseInt($(b).attr('ordre-tri'));
        if (elementA == elementB) {
            var nameA = $(a).attr('name');
            var nameB = $(b).attr('name');
            var composanteA = parseInt(nameA.substring(nameA.lastIndexOf('-') + 1, nameA.length));
            var composanteB = parseInt(nameB.substring(nameB.lastIndexOf('-') + 1, nameB.length));
            if (composanteA == composanteB) {
                var noLigneA = parseInt($(a).find('.panel-group').attr('no-ligne'));
                var noLigneB = parseInt($(b).find('.panel-group').attr('no-ligne'));
                return noLigneA > noLigneB ? 1 : noLigneA < noLigneB ? -1 : 0;
            }
            return composanteA > composanteB ? 1 : composanteA < composanteB ? -1 : 0;
        }
        return elementA > elementB ? 1 : elementA < elementB ? -1 : 0;
    });
    repereContainer.first().append(divAccordionsOrderedDivs);
}


/**
 * Fonction permettant de venir nettoyer le QC ainsi que les repères du bloc 15 lorsque l'usager modifie les choix de fondations ou % corespondants dans le bloc
 */
function nettoyerResultatsQcb15(element) {
    var idComposante = element.closest('.blocForm').find('.qc [name="composante"]').val();
    var reperesContainer = getReperesContainer($(this));
    var selecteurComposante = reperesContainer.find('[id^="qc-composante-' + idComposante + '"]').find('[id-composante="' + idComposante + '"]');
    var caseResultat = selecteurComposante.find('.resultat');
    var qcBloc = reperesContainer.find('.qc').find('[name="composante"][value="' + idComposante + '"]').closest('.qc').find('[name$="qualiteComplexite"]');
    caseResultat.html('');
    qcBloc.val('');

    // cacher les repères de fondation selon les types de fondation saisis dans le bloc 15
    cacherRepereParTypeFondationQcb15(reperesContainer);

    calculerClasseQC(reperesContainer, idComposante, 1);
}

function cacherRepereParTypeFondationQcb15(reperesContainer) {
    var fondationsType1 = [3, 6, 7]; // partie "Fondations (sous-sol, muret ou vide sanitaire)"
    var fondationsType2 = [1, 2, 4, 5]; // partie "Fondations (radier, piliers ou sole)"
    var nbType1 = 0;
    var nbType2 = 0;
    var blocsContainer = reperesContainerToBlocsContainer(reperesContainer);
    var fondationsSupprimees = blocsContainer.find('#b15-fondation-sous-bloc').find('.suppression-ligne [name="typeFondation"], .suppression-ligne-sauvegardee [name="typeFondation"]');
    var fondationsSaisiesDansLeBloc = blocsContainer.find('#b15-fondation-sous-bloc').find('[name="typeFondation"]').not(fondationsSupprimees);
    $.each(fondationsSaisiesDansLeBloc, function (idx, input) {
        var idTypeFondation = parseInt($(input).val());
        var pourcentage = $(input).closest('.sous-bloc-form').find('#form-pourcentage').val();
        if (pourcentage != '') {
            if ($.inArray(idTypeFondation, fondationsType1) > -1) {
                nbType1 += 1;
            }
            else if ($.inArray(idTypeFondation, fondationsType2) > -1) {
                nbType2 += 1;
            }
        }
    });

    var idComposante = 1; // Fondations
    var qcComposante = reperesContainer.find('[name=accordion-qc-composante-' + idComposante + ']');
    // afficher les deux parties et ses repères: si les 2 types de fondation ont été saisis ou si aucun type de fondation est saisi
    qcComposante.find('.type-repere-fondation-1, .type-repere-fondation-2').css('display', '');
    qcComposante.find('.type-repere-fondation-1 .repere, .type-repere-fondation-2 .repere').removeClass('display-none');
    if (nbType1 > 0 && nbType2 == 0) {
        // cacher la partie du type 2 si seulement le type de fondation 1 a été saisi
        qcComposante.find('.type-repere-fondation-2').css('display', 'none');
        qcComposante.find('.type-repere-fondation-2 .repere').addClass('display-none');
    }
    else if (nbType2 > 0 && nbType1 == 0) {
        // cacher la partie du type 1 si seulement le type de fondation 2 a été saisi
        qcComposante.find('.type-repere-fondation-1').css('display', 'none');
        qcComposante.find('.type-repere-fondation-1 .repere').addClass('display-none');
    }
}

function isTypeMurFondationMuret() {
    const batiMurs = $('#b12-bati-mur').find('.sous-bloc-form:not(.nouvelle-ligne)');
    let totalPourcentage = 0;
    let countPtie3 = 0;
    let countPtieNon3 = 0;
    let isMurFondationMuret = false;
    $.each(batiMurs, function (idx, element) {
        const $element = $(element);
        const ptie = $element.find('select[name="partieMur"]').val();
        const pourcentage = parseFloat(
            $element.find('input[name="pourcentage"]').val()
        ) || 0;
        if (ptie === '3') {
            countPtie3++;
            totalPourcentage += pourcentage;
        } else {
            countPtieNon3++;
        }
    });
    if (countPtie3 === 0 || countPtieNon3 > 0) return false; // s'il n'a aucun muret
    if (countPtie3 >= 1 && totalPourcentage === 100) isMurFondationMuret = true; // si on a un ou plusieurs muret, le pourcentage doit être à 100%

    return isMurFondationMuret;
}

function calculerClasseQC(reperesContainer, idComposante, noLigne) {
    var selecteurComposante = reperesContainer.find('[name=accordion-qc-composante-' + idComposante + '][no-ligne="' + noLigne + '"]').find('[id^="qc-composante-' + idComposante + '"]');
    var caseResultat = selecteurComposante.find('.resultat');

    var blocsContainer = reperesContainerToBlocsContainer(reperesContainer);
    var qcComposante = blocsContainer.find('.qc').find('[name$="composante"][value="' + idComposante + '"]');
    var qcBloc = qcComposante.closest('.sous-bloc-form[no-ligne="' + noLigne + '"]').find('[name$="qualiteComplexite"]');

    var calcul = 0;
    var calcul2 = 0;
    var totalPonderation = 0;
    var totalPonderation2 = 0;
    var valeurClasse = {'A': 1, 'B': 2, 'C': 3, 'D': 4, 'E': 5};
    var classeValeur = {1: 'A', 2: 'B', 3: 'C', 4: 'D', 5: 'E'};

    var selecteurReperes = selecteurComposante.find('.repere').not('.display-none');
    var nbRepere = selecteurReperes.length;
    var boolShowResultat = true;
    var boolRepereOuvertureFondationFacultatif = reperesContainer.attr('repere-ouverture-facultatif') == 'True';

    // On itère sur la liste des repères de la composante sélectionnée
    $.each(selecteurReperes, function (idx, row) {
        var repereColumns = $(row).find('.cell-repere');
        var ponderation = parseInt(repereColumns.eq(1).attr('ponderation')); // On obtient la pondération du repère courant
        var classe = repereColumns.eq(7).html(); // On obtient la classe sélectionnée du repère courant

         // Lorsqu'on veut calculer pour les Q.C
        if (idComposante == 50 && boolRepereOuvertureFondationFacultatif && isTypeMurFondationMuret() ) {
            // Il faut savoir si les 2 premiers repères ont été saisis
            if (idx < 2) {
                // On vérifie si les 2 premiers repères sont sélectionnés
                if (classe == '') {
                    boolShowResultat = false;
                }
            } else if (idx == 2) {
                // Le 3ème repère est optionnel, on ajuste la pondération si non sélectionné
                if (classe == '') {
                    // Recalculer les pondérations pour les 2 premiers repères seulement
                    var pond1 = parseInt(selecteurReperes.eq(0).find('.cell-repere').eq(1).attr('ponderation'));
                    var pond2 = parseInt(selecteurReperes.eq(1).find('.cell-repere').eq(1).attr('ponderation'));
                    var totalPond = pond1 + pond2;

                    // Recalculer avec pondération ajustée
                    calcul = 0;
                    totalPonderation = 0;

                    var classe1 = selecteurReperes.eq(0).find('.cell-repere').eq(7).html();
                    var classe2 = selecteurReperes.eq(1).find('.cell-repere').eq(7).html();

                    if (classe1 != '' && classe2 != '') {
                        var nouvellepond1 = (pond1 * 100) / totalPond;
                        var nouvellepond2 = (pond2 * 100) / totalPond;
                        calcul += (pond1 / totalPond) * valeurClasse[classe1];
                        calcul += (pond2 / totalPond) * valeurClasse[classe2];
                        totalPonderation = nouvellepond1 + nouvellepond2;
                    }
                }
            }
        }

        if (classe != '') {

            // On détecte le cas où l'on retrouve deux groupes de repère distinct pour la même composante (ex: b15) afin d'appliquer une pondération
            if (totalPonderation == 100) {
                calcul2 += ponderation / 100 * valeurClasse[classe];
                totalPonderation2 += ponderation;
            } else {
                totalPonderation += ponderation;
                calcul += ponderation / 100 * valeurClasse[classe];
            }
        }

        // Lorsque tous les repères ont été calculés on affiche le résultat
        if (idx == nbRepere - 1) {
            var calculArrondi;

            //Exception pour le b15 qui contient deux groupes de repères distincts
            if (idComposante == 1) {
                var fondationsType1 = [3, 6, 7];
                var fondationsType2 = [1, 2, 4, 5];
                var sumPourcentType1 = 0;
                var sumPourcentType2 = 0;
                var fondationsSupprimees = blocsContainer.find('#b15-fondation-sous-bloc').find('.suppression-ligne [name="typeFondation"], .suppression-ligne-sauvegardee [name="typeFondation"]');
                var fondationsSaisiesDansLeBloc = blocsContainer.find('#b15-fondation-sous-bloc').find('[name="typeFondation"]').not(fondationsSupprimees);
                $.each(fondationsSaisiesDansLeBloc, function (idx, input) {
                    var idTypeFondation = parseInt($(input).val());
                    var pourcentage = parseInt($(input).closest('.sous-bloc-form').find('#form-pourcentage').val());
                    if ($.inArray(idTypeFondation, fondationsType1) > -1)sumPourcentType1 += pourcentage;
                    else if ($.inArray(idTypeFondation, fondationsType2) > -1)sumPourcentType2 += pourcentage;
                });

                // Si on a des fondations des 2 types dans le bloc 15 alors on fait une pondération du calcul avec les pourcentages
                if (sumPourcentType1 > 0 && sumPourcentType2 > 0) {
                    if (totalPonderation == 100 && totalPonderation2 == 100)calculArrondi = Math.round((sumPourcentType1 / 100 * calcul) + (sumPourcentType2 / 100 * calcul2));
                    else boolShowResultat = false;
                }
                else if (sumPourcentType2 > 0 || sumPourcentType1 > 0) {
                    if (totalPonderation == 100) {
                        calculArrondi = Math.round(calcul);
                    } else {
                        boolShowResultat = false;
                    }
                }
                else boolShowResultat = false;
            } else {
                if (totalPonderation == 100) {
                    calculArrondi = Math.round(calcul);
                } else {
                    boolShowResultat = false;
                }
            }
            //console.log('calculArrondi: ' + calculArrondi);
            var modeReadOnly = estReadOnly(reperesContainer); // $('#mode-read-only').val() || 'False';
            var selecteurComposanteId = selecteurComposante.attr('id');
            if (boolShowResultat) {
                var classeCalculee = classeValeur[calculArrondi];
                caseResultat.html(classeCalculee); // On actualise le résultat de la classe dans la fenêtre modal
                if (!modeReadOnly) {
                    qcBloc.val(classeCalculee); // On actualise le résultat de la classe dans le champs QC du bloc
                    //    On ajoute ou met à jour le résultat du calcul de la classe des QC dans l'entête du modal des repères
                    mettreAJourEnteteReperes(selecteurComposanteId, classeCalculee);

                }
            } else { // On vide les résultats si tous les repères n'ont pas été saisie
                caseResultat.html('');
                if (!modeReadOnly) {
                    qcBloc.val('');
                    //    On efface le résultat du calcul de la classe de l'entête du modal des repères
                    mettreAJourEnteteReperes(selecteurComposanteId, null);
                }
            }
            // On force le event change une fois la valeur du qc modifié
            qcBloc.trigger('change');
        }

    });
}


function mettreAJourEnteteReperes(repere, valeur) {
    var entete = $('#entete-fixe-reperes').find('a[value="#' + repere + '"]');
    var enteteValeur = $(entete).find('span.classe-calculee');
    var nombreLignesSelectionnees = $('#' + repere).find('div.cell-repere.selected').length;

    // On met à jour la couleur
    if (nombreLignesSelectionnees > 0) {
        if (!$(entete).find('span.lien.reperes-modal').hasClass('donnees')) {
            $(entete).find('span.lien.reperes-modal').addClass('donnees');
        }
    } else if (nombreLignesSelectionnees === 0) {
        $(entete).find('span.lien.reperes-modal').removeClass('donnees');
    }

    // On met à jour la valeur de la classe retenue
    if (valeur === null) {
        if (enteteValeur.length > 0) {
            $(enteteValeur).text('');
        }
    } else {
        if (enteteValeur.length > 0) { // On met à jour
            $(enteteValeur).text('').text('(' + valeur + ')');
        } else { // On ajoute
            var html = ' <span class="classe-calculee">(' + valeur + ')</span>';
            $(entete).append(html);
        }
    }
}


function initEventsReperes(reperesContainer) {

    var containerRepere = reperesContainer;

    containerRepere.find('.click').off('click').on('click', function () {

        var thisButton = $(this);

        $(this).parent().find('.selected').not(this).toggleClass('selected');
        $(this).toggleClass('selected');

        var idRepere = 'None';
        if ($(this).hasClass('selected')) {
            idRepere = $(this).attr('id-repere');
            var classe = $(this).attr('classe-repere');
            $(this).parent().find('.choix-classe').html(classe);
        }
        else {
            $(this).parent().find('.choix-classe').html('');
        }

        // // marquer la modification
        $(this).closest('.repere').addClass('repere-modifie');

        var blocsContainer = reperesContainerToBlocsContainer(reperesContainer);
        var idBloc = $(this).closest('[name^=accordion-qc-composante-]').attr('ordre-tri');

        var callback = function () {
            var idComposante = thisButton.closest('.container-repere').attr('id-composante');
            var noLigne = thisButton.closest('[name=accordion-qc-composante-' + idComposante + ']').attr('no-ligne');
            calculerClasseQC(reperesContainer, idComposante, noLigne);
        };

        assurerBlocOuvert(blocsContainer, idBloc, callback);
    });
}


function assurerBlocOuvert(blocsContainer, idBloc, callback) {
    if ($('#wizard').length > 0) {
        var accordionBatiment = blocsContainer.closest('[id^=accordion-batiment-]');
        var accordionBlocs = accordionBatiment.find('[id^=accordion-propagation-]');

        accordionBlocs.each(function () {
            var idAccordion = $(this).attr('id');
            var idAccordionSplit = idAccordion.split('-');
            var idBlocAccordion = idAccordionSplit[4];

            if (idBlocAccordion == idBloc) {
                $(this).find('h4 > a').filter(".collapsed").click();
            }
        });

        if (typeof(callback) != 'undefined') {
            callback();
        }
    }
    else {
        var objBloc = $('form.blocForm[id_bloc=' + idBloc + ']');
        if (objBloc.find(':contains(Aucune donnée dans ce bloc.)').length) {
            chargerBloc(idBloc, callback);
        }
        else {
            if (typeof(callback) != 'undefined') {
                callback();
            }
        }
    }
}


function getParamsLigneSousBlocRepere(reperesContainer, ligne) {
    var params = [];
    var ligneStatut = LIGNE_STATUT.none;
    var idRepere = ligne.find('.cell-repere.click.selected').attr('id-repere');
    var idModelInstance = ligne.attr('id-model-instance');
    var noLigne = ligne.closest('[name^=accordion-qc-composante]').attr('no-ligne');
    var idComposante = ligne.closest('.container-repere').attr('id-composante');
    var idSousBlocParent = ligne.attr('id-sous-bloc-parent');
    var blocsContainer = reperesContainerToBlocsContainer(reperesContainer);
    var qc = blocsContainer.find('.sous-bloc-form .qc').find('[name$="composante"][value="' + idComposante + '"]');
    if (idSousBlocParent == 'None') {
        // cherche dans les sous-blocs imbriqués
        idSousBlocParent = qc.closest('.sous-bloc-form[no-ligne="' + noLigne + '"]').attr('id-model-instance');

        // cas d'une nouvelle ligne
        if (idSousBlocParent == 'None') {
            idSousBlocParent = '';
        }
    }

    if (idRepere == undefined || ligne.hasClass('repere-suppression')) {
        ligneStatut = LIGNE_STATUT.delete;
        params.push({name: 'repere', value: ""});
    }
    // Cas d'un ajout ou d'une modification
    else {
        ligneStatut = idModelInstance != 'None' ? LIGNE_STATUT.update : LIGNE_STATUT.insert;
        params.push({name: 'repere', value: idRepere});
        if (idSousBlocParent != undefined) {
            switch (idComposante) {
                case '13':
                    params.push({name: 'b59Foyer', value: idSousBlocParent});
                    break;
                case '21':
                case '22':
                case '23':
                case '24':
                    params.push({name: 'b63DependanceDetachee', value: idSousBlocParent});
                    break;
            }
        }
    }

    return {'params': params, 'ligneStatut': ligneStatut};
}
